import { Typography } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import type { PlanInputFormUsageProduct } from '@weft/types';
import { withDefault } from '@weft/utils';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { getDefaultPerUnitUsageProduct, getDefaultRevShareUsageProduct, getDefaultTieredSubscriptionUsageProduct,
  getDefaultTiersUsageProduct,
  getDefaultVolumeUsageProduct } from '../../../../../create-plan-page-consts/add-item-button-consts';
import type { NewPlanForm } from '../../../../CreatePlanForm/create-plan-form-types/new-plan-form';
import type { PlanInputForm } from '../../../../CreatePlanForm/create-plan-form-types/plan-input-form';

export const UsageChargesMenuItems: React.FC = () => {
  const { setValue, getValues } = useFormContext<PlanInputForm, NewPlanForm>();

  const handleProductClick = (defaultProductCallback: () => PlanInputFormUsageProduct) => {
    return () => {
      const currentProducts = withDefault(getValues('usageProducts'), []);
      const defaultProduct = defaultProductCallback();
      const updatedProducts = [...currentProducts, defaultProduct];
      setValue('usageProducts', updatedProducts as PlanInputForm['usageProducts']);
    };
  };

  return (
    <>
      <MenuItem
        className="flex flex-col items-start"
        onClick={handleProductClick(getDefaultTiersUsageProduct)}
      >
        <Typography className="text-sm font-normal text-black">Tiered Pricing</Typography>
        <Typography className="text-xs font-normal text-[#94A0A4]">Consumption in a tier</Typography>
      </MenuItem>

      <MenuItem
        className="flex flex-col items-start"
        onClick={handleProductClick(getDefaultTieredSubscriptionUsageProduct)}
      >
        <Typography className="text-sm font-normal text-black">Tiered Subscription Pricing</Typography>
        <Typography className="text-xs font-normal text-[#94A0A4]">Fixed tier rate recurring</Typography>
      </MenuItem>

      <MenuItem
        className="flex flex-col items-start"
        onClick={handleProductClick(getDefaultPerUnitUsageProduct)}
      >
        <Typography className="text-sm font-normal text-black">Per Unit Pricing</Typography>
        <Typography className="text-xs font-normal text-[#94A0A4]">Fixed fee per unit</Typography>
      </MenuItem>

      <MenuItem
        className="flex flex-col items-start"
        onClick={handleProductClick(getDefaultVolumeUsageProduct)}
      >
        <Typography className="text-sm font-normal text-black">Volume Pricing</Typography>
        <Typography className="text-xs font-normal text-[#94A0A4]">Cumulative usage rate</Typography>
      </MenuItem>

      <MenuItem
        className="flex flex-col items-start"
        onClick={handleProductClick(getDefaultRevShareUsageProduct)}
      >
        <Typography className="text-sm font-normal text-black">Revenue Share</Typography>
        <Typography className="text-xs font-normal text-[#94A0A4]">Percentage from total amount</Typography>
      </MenuItem>
    </>
  );
};